import { utils, t } from '@hh/global.js'

const { prefersReducedMotion, isTablet } = utils
class HHMobileMenu extends HTMLElement {
  constructor() {
    super()

    this._open = false

    this.toggleFn = this.toggleFn.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.handleOutsideEvent = this.handleOutsideEvent.bind(this)
    this.onKeyup = this.onKeyup.bind(this)
    this.mainHeader = this.closest('hh-header')
  }

  connectedCallback() {
    this.toggle = this.querySelector('.js-mobile-trigger')
    this.menu = this.querySelector('.js-mobile-menu-container')

    this.toggle.addEventListener('click', this.toggleFn)
    document.addEventListener('focusin', this.handleOutsideEvent)
    this.addEventListener('keyup', this.onKeyup)
  }

  disconnectedCallback() {
    this.toggle.removeEventListener('click', this.toggleFn)
    document.removeEventListener('focusin', this.handleOutsideEvent)
    this.removeEventListener('keyup', this.onKeyup)
  }

  onKeyup(e) {
    if (e.code.toUpperCase() === 'ESCAPE') this.toggle.click()
  }

  toggleFn(e) {
    e.preventDefault()
    this._open ? this.close() : this.open()
  }

  updateMobileMenuHeight() {
    if (!this.mainHeader || !this.menu) return;

    const headerRect = this.mainHeader.getBoundingClientRect();
    const headerBottom = headerRect.bottom;
    const windowHeight = window.innerHeight;
    const availableHeight = windowHeight - headerBottom;

    this.menu.style.height = `${availableHeight}px`;
  }

  open() {
    this._open = true

    this.addBodyListener()

    setTimeout(() => {
      this.updateMobileMenuHeight();
    }, 100);

    this.toggle.setAttribute('aria-expanded', true)
    this.toggle.setAttribute(
      'aria-label',
      t('accessibility.close_mobile_menu', 'Close mobile menu')
    )
    this.broadcast(true)
  }

  close() {
    this._open = false
    this.removeBodyListener()
    this.toggle.setAttribute('aria-expanded', false)
    this.toggle.setAttribute(
      'aria-label',
      t('accessibility.open_mobile_menu', 'Open mobile menu')
    )
    this.broadcast(false)
  }

  addBodyListener() {
    document.body.classList.add('scroll-lock')
    document.querySelector('html').classList.add('scroll-lock')

    // Store current scroll position to prevent jump
    this.scrollPosition = window.pageYOffset

    document.body.style.top = `-${this.scrollPosition}px`
    document.body.style.position = 'fixed'
  }

  removeBodyListener() {
    document.body.classList.remove('scroll-lock')
    document.querySelector('html').classList.remove('scroll-lock')

    // Restore scroll position and remove fixed positioning
    document.body.style.removeProperty('top')
    document.body.style.removeProperty('position')
    window.scrollTo(0, this.scrollPosition || 0)
  }

  broadcast(e) {
    this.dispatchEvent(
      new CustomEvent('mobileMenuOpened', {
        bubbles: true,
        composed: true,
        detail: {
          value: e,
        },
      })
    )
  }

  handleOutsideEvent(e) {
    if (!this.contains(e.target) && this._open) {
      this.toggle.click()
    }
  }
}

customElements.define('hh-mobile-menu', HHMobileMenu)
